<div class="container mx-auto px-4 py-6">
  <div class="mb-6">
    <h1 class="text-3xl font-bold text-gray-800">🛡️ Solicitações LGPD</h1>
    <p class="text-gray-600 mt-2">Fila de aprovações e rejeições de remoção de dados</p>
  </div>

  <div class="bg-white rounded-lg shadow p-6 mb-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Status</label>
        <select [(ngModel)]="status" (change)="load()" class="w-full px-3 py-2 border border-gray-300 rounded-md">
          <option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.label }}</option>
        </select>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="bg-white rounded-lg shadow overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fornecedor</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Solicitante</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Motivo</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Notas Admin</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let r of items" class="hover:bg-gray-50">
            <td class="px-6 py-4">
              <div class="text-sm font-medium text-gray-900">{{ r.fornecedor?.nome || '—' }}</div>
              <div class="text-xs text-gray-500">ID: {{ r.fornecedor?.id || '—' }}</div>
            </td>
            <td class="px-6 py-4">
              <div class="text-sm text-gray-900">{{ r.requesterEmail }}</div>
              <div class="text-xs text-gray-500">IP: {{ r.requesterIpAddress || '—' }}</div>
            </td>
            <td class="px-6 py-4">
              <div class="text-sm text-gray-900">{{ r.reason }}</div>
              <div class="text-xs text-gray-500">{{ r.description || '—' }}</div>
            </td>
            <td class="px-6 py-4">
              <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                [ngClass]="getStatusClass(r.status)">{{ r.status }}</span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap">
              <div class="text-sm text-gray-900">{{ r.requestedAt | date: 'dd/MM/yyyy' }}</div>
              <div class="text-sm text-gray-500">{{ r.requestedAt | date: 'HH:mm' }}</div>
            </td>
            <td class="px-6 py-4 text-sm text-gray-500">
              <span *ngIf="r.adminNotes" class="text-xs bg-gray-50 px-2 py-1 rounded border">{{ r.adminNotes }}</span>
              <span *ngIf="!r.adminNotes" class="text-xs text-gray-400">—</span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
              <button *ngIf="r.status === 'Pending' || r.status === 'pending'"
                (click)="openApprove(r)" class="text-green-600 hover:text-green-900 font-semibold">✅ Aprovar</button>
              <button *ngIf="r.status === 'Pending' || r.status === 'pending'"
                (click)="openReject(r)" class="text-red-600 hover:text-red-900 font-semibold">❌ Rejeitar</button>
              <span *ngIf="r.status !== 'Pending' && r.status !== 'pending'"
                class="text-gray-400 text-xs italic">Processado</span>
            </td>
          </tr>
          <tr *ngIf="items.length === 0">
            <td colspan="7" class="px-6 py-12 text-center text-gray-500">
              <div class="text-4xl mb-2">🛡️</div>
              <p>Nenhuma solicitação encontrada</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="bg-white px-4 py-3 border-t border-gray-200 sm:px-6">
      <div class="flex items-center justify-between">
        <p class="text-sm text-gray-700">
          Mostrando
          <span class="font-medium">{{ (page - 1) * pageSize + 1 }}</span>
          até
          <span class="font-medium">{{ displayEnd() }}</span>
          de
          <span class="font-medium">{{ total }}</span>
          resultados
        </p>
        <app-pagination [page]="page" [pageSize]="pageSize" [total]="total" (pageChange)="onPageChange($event)"></app-pagination>
      </div>
    </div>
  </div>
</div>

<!-- ===== Action Modal (Approve / Reject) ===== -->
<div *ngIf="showActionModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg shadow-xl w-full max-w-md">
    <div class="px-6 py-4 border-b flex items-center justify-between"
      [ngClass]="actionType === 'approve' ? 'bg-green-50' : 'bg-red-50'">
      <h2 class="text-xl font-semibold"
        [ngClass]="actionType === 'approve' ? 'text-green-800' : 'text-red-800'">
        {{ actionType === 'approve' ? '✅ Aprovar Solicitação' : '❌ Rejeitar Solicitação' }}
      </h2>
      <button (click)="closeActionModal()" class="text-gray-400 hover:text-gray-600 text-2xl">&times;</button>
    </div>
    <div class="px-6 py-4">
      <div *ngIf="selectedItem" class="mb-4 bg-gray-50 rounded-md p-3 text-sm">
        <div class="font-medium text-gray-800">{{ selectedItem.fornecedor?.nome || selectedItem.requesterEmail }}</div>
        <div class="text-gray-500 mt-1">Motivo: {{ selectedItem.reason }}</div>
        <div *ngIf="selectedItem.description" class="text-gray-500 text-xs mt-0.5">{{ selectedItem.description }}</div>
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Notas do Admin
          <span *ngIf="actionType === 'reject'" class="text-red-500">*</span>
          <span *ngIf="actionType === 'approve'" class="text-gray-400 font-normal">(opcional)</span>
        </label>
        <textarea [(ngModel)]="actionNotes" rows="3"
          [placeholder]="actionType === 'approve' ? 'Ex: Dados removidos com sucesso' : 'Explique o motivo da rejeição...'"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 resize-none"
          [ngClass]="actionType === 'approve' ? 'focus:ring-green-500' : 'focus:ring-red-500'"></textarea>
      </div>

      <div class="mt-4 flex justify-end gap-3 border-t pt-4">
        <button (click)="closeActionModal()"
          class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50 text-sm">Cancelar</button>
        <button (click)="confirmAction()"
          [disabled]="actioning || (actionType === 'reject' && !actionNotes)"
          class="px-4 py-2 text-white rounded-md text-sm disabled:opacity-60"
          [ngClass]="actionType === 'approve' ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'">
          {{ actioning ? 'Processando...' : (actionType === 'approve' ? '✅ Confirmar Aprovação' : '❌ Confirmar Rejeição') }}
        </button>
      </div>
    </div>
  </div>
</div>

